import React from 'react';
import '../../news-pages.css'
import Parse from 'html-react-parser'

import OwlCarousel from 'react-owl-carousel'
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.default.css'

import pic1 from './pic1.jpg'
import pic2 from './pic2.jpg'
import pic3 from './pic3.jpg'
import pic4 from './pic4.jpg'


const Page = () => {

    const detail = 
        {
            id:1,
            imgSrc:pic1,
            ini:'CMU research teams & French partners met with the Chiang Dao District Chief to launch CHAZEP-SEA',
            href:'CMU research teams & French partners met with the Chiang Dao District Chief to launch CHAZEP-SEA',
            element:'',
            topic:'',
            inform: `On November 7, 2025, Asst. Prof. Dr. Marco J. Haenssgen and a research team from the Faculty of Social Sciences, Chiang Mai University, along with Asst. Prof. Dr. Woottichai Kamduang, Dr. Nicole Ngo-Giang-Huong, and a research team from the Faculty of Associated Medical Sciences, Chiang Mai University, accompanied by Dr. Alessandra Manzini from CY Cergy Paris University, France, met and discussed with the Chiang Dao District Chief, at the Chiang Dao District Office. The discussion aimed to establish cooperation guidelines for the CHAZEP-SEA project (Co-Developing Heritage-sensitive Approaches for Zoonotic Emergence Prevention in Southeast Asia). The project focuses on developing a 'Heritage-sensitive One Health' approach, emphasizing the prevention of zoonotic diseases in ethnic communities within the Doi Chiang Dao Biosphere Reserve. It prioritizes co-creating knowledge with local communities to foster a sustainable understanding of human, animal, and environmental health. Furthermore, the project aims to strengthen cooperation between academic institutions and local agencies in developing a 'One Health' approach that aligns with the community's way of life and cultural values.`,
            link1: `https://www.facebook.com/permalink.php?story_fbid=pfbid0deM2kFw3Vo7H5ZFG1hSUZTUMv39jFs4mcZzsH8XXfyQNgrHuF8bumun7azUa1cmtl&id=100089824854973`,
        }
    
        
        const handleLink1 = () =>{
            window.open(detail.link1, '_blank', 'noreferrer')
        }

    const imgs = [
        {
            imageSrc: pic1,
            alt: 'pic1',
            title: 'pic1',
            thumbnailImageSrc: pic1
        },
        {
            imageSrc: pic2,
            alt: 'pic2',
            title: 'pic2',
            thumbnailImageSrc: pic2
        },
        {
            imageSrc: pic3,
            alt: 'pic3',
            title: 'pic3',
            thumbnailImageSrc: pic3
        },
        {
            imageSrc: pic4,
            alt: 'pic4',
            title: 'pic4',
            thumbnailImageSrc: pic4
        }
    ]

    return (
        <div className='elements containers'>
            <div className="img-slicer">
                <OwlCarousel
                    className='owl-theme'
                    loop={true}
                    margin={10}
                    lazyLoad={true}
                    nav
                    items={1}
                    autoplay={true}
                    autoplayTimeout={3000}
                    autoplayHoverPause={true}
                    smartSpeed={1000}
                >
                    {imgs.map((img,index)=>(
                        <div className="item" key={index}><img src={img.imageSrc} alt="item" /></div>
                    ))}
                </OwlCarousel>
            </div>
            <div className="text">
                <h1>{detail.ini}</h1>
                <h2>{Parse(detail.topic)}</h2>
                <p>{Parse(detail.inform)}</p>
                <div className="btn">
                    <h2>MORE INFORMATION</h2>
                    <button onClick={handleLink1}>{detail.link1}</button>
                </div>
            </div>
        </div>
    );
}

export default Page;
